import React, { useState, useEffect } from "react";
import { Routes, Route, HashRouter } from "react-router-dom";
import "./App.css";
import Login from "./Component/Login/Login";
import { useDispatch } from "react-redux";
import { addUser } from "./Component/Redux/Action/userAction";

import { Dashboardpage } from "./Pages/Dashboardpage";
import Header from "./Component/Header/Header";
import Homepagedetails from "./Pages/Homepagedetails";
import { Logintab } from "./Component/Login/Logintab";
import { Toast } from "./Component/Toast";
import { Ticketpage } from "./Pages/Ticketpage";
import TicketDetails from "./Component/TicketDetails/TicketDetails";
import OcrPage from "./Component/OCRpage/OcrPage";
import { useSelector } from "react-redux";
import ProtectedRoute from "./Component/Header/ProtectedRoute";
import ReportForm from "./Component/ReportForm/ReportForm";
import ClaimReport from "./Component/ReportForm/ClaimReport";
import ReportDetails from "./Component/ReportForm/ReportDetails";
import ReportViewPage from "./Component/ReportForm/ReportViewPage";
function App() {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);
  const formfilled = useSelector((state) => state.form.formfilled);
  useEffect(() => {


    console.log("first", formfilled)
    const authenticateUser = async () => {
      try {
        if (!window.catalyst || !window.catalyst.auth) {
          console.error("Catalyst SDK is not available");
          return;
        }

        const authResult = await window.catalyst.auth.isUserAuthenticated();
        dispatch(addUser(authResult.content));

        if (!sessionStorage.getItem("userRole")) {
          const { email_id, first_name, last_name } = authResult.content;
          const userManagement = window.catalyst.userManagement;

          const currentUserResponse =
            await userManagement.getCurrentProjectUser();

          const {
            role_details: { role_name, role_id },
            user_id,
            email_id: email,
          } = currentUserResponse.content;

          sessionStorage.setItem("userRole", role_name);
          sessionStorage.setItem("roleId", role_id);
          sessionStorage.setItem("userId", user_id);
          sessionStorage.setItem("email", email);
          sessionStorage.setItem("first_name", first_name);
          sessionStorage.setItem("last_name", last_name);

          if (window.location.hash !== "#/home") {
            window.location.href = "/#/home";
          }
        }
      } catch (error) {
        console.error("Authentication error", error);
      } finally {
        setLoading(false);
      }
    };

    authenticateUser();
  }, [dispatch, formfilled]);

  if (loading) {
    return (
      <div className="h-screen w-screen flex items-center justify-center bg-white">
        <div className="animate-spin rounded-full h-12 w-12 border-4 border-red-500 border-t-transparent"></div>
      </div>
    );
  }

  return (
    <HashRouter>
      <Routes>

        <Route path="/" element={<Logintab />} />
        
        <Route path="/home" element={
          <ProtectedRoute>
          <Homepagedetails />
          </ProtectedRoute>} />
        <Route path="/dash" element={
          <ProtectedRoute>
            <Dashboardpage />
          </ProtectedRoute>
        } />

        <Route path="/ticket" element={
          <ProtectedRoute>
            <Ticketpage />
          </ProtectedRoute>
        } />

        <Route path="/ticketdetails" element={
          <ProtectedRoute>
            <TicketDetails />
          </ProtectedRoute>
        } />

        <Route path="/uploadbill" element={
          <ProtectedRoute>
            <OcrPage />
          </ProtectedRoute>
        } />

        <Route path="/header" element={
          <ProtectedRoute>
            <Header />
          </ProtectedRoute>
        } />

        <Route path="/profile" element={
          <ProtectedRoute>
            <Toast />
          </ProtectedRoute>
        } />


        <Route path="/reportform" element={
          <ProtectedRoute>
            <ReportForm />
          </ProtectedRoute>
        } />
        <Route path="/report" element={
          <ProtectedRoute>
            <ReportDetails />
          </ProtectedRoute>
        } />
        <Route path="/report-view" element={
          <ProtectedRoute>
            <ReportViewPage />
          </ProtectedRoute>
        } />
        <Route path="/claimreport" element={
          <ProtectedRoute>
            <ClaimReport />
          </ProtectedRoute>
        } />
      </Routes>
    </HashRouter>
  );
}
export default App;
